import {getInitialMeta} from "@helpers/HelperInitialPageState";
// Data file for component
///////////////////////////////////////////////////////////////////////////////////////////
import flag from '@baseImg/icons/shortcake.webp';

const BG = {
	page: 'Order',
	brandColor: 'color-brand-orange-400',
	height: 'longCommon',
	list: [],
	infoBar: {
		//text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> Ставаме на 21 и растем заедно с AI! Създай своя нов сайт с до 78% отстъпка до 29 октомври!',
		buttonText: 'Поръчай',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const EN = {
	page: 'Order',
	brandColor: 'color-brand-orange-400',
	height: 'longCommon',
	list: [],
	infoBar: {
		//text: '<img src="' + flag + '" alt="Flash sale" title="Flash sale - SuperHosting.BG" width="22" height="22"/> We\'re turning 21 and growing together with AI! Create your new website with up to 78% off until Oct. 29!',
		buttonText: 'Order',
		buttonUrl: getInitialMeta('siteURL') + 'web-hosting-register-domains.php',
		layout: 'default'
	}
}

///////////////////////////////////////////////////////////////////////////////////////////

const dataMap = {
	bg: BG,
	en: EN
};
const lang = getInitialMeta('pageLang') ?? 'bg';

///////////////////////////////////////////////////////////////////////////////////////////

export default dataMap[lang];